<template>
  <div>
    <br class="hidden-md hidden-lg" />

    <button class="btn btn-block" @click="goAccount()">My Account</button>

    <button class="btn btn-block" @click="goBookings()">
      <i class="fa fa-check-circle-o"></i> My Bookings
    </button>
    <button class="btn btn-block" @click="goCalendar()">
      <i class="fa fa-calendar"></i> Calendar and Availability
    </button>
    <button class="btn btn-block" @click="goProfileSetup()">
      <i class="fa fa-address-card-o"></i> Profile Setup
    </button>

    <button class="btn btn-block" @click="goViewPublicProfile()">
      View Public Profile
    </button>

    <button class="btn btn-block" @click="goContactSupport()">
      <i class="fa fa-support"></i> Contact Support
    </button>
  </div>
</template>

<script>
import router from "../../router";
import store from "../../data/store";

const API_URL = "https://www.dupaws.com/services/";
export default {
  name: "shortcuts",
  data() {
    return {};
  },
  computed: {
    sitterIdComp: function () {
      if (store.getters.SitterId != null) {
        return "/sitter/" + store.getters.SitterId;
      }
    },
  },
  methods: {
    goAccount() {
      router.push({ path: "/account", force: true });
    },
    goBookings() {
      router.push({ path: "/my-sitter-reservations", force: true });
    },
    goProfileSetup() {
      router.push({ path: "/sitter-profile-edit/about", force: true });
    },
    goViewPublicProfile() {
      router.push({ path: this.sitterIdComp });
    },
    goContactSupport() {
      router.push({ path: "/contact-support", force: true });
    },
    goCalendar() {
      router.push({ path: "/sitter-profile-edit/calendar", force: true });
    },
  },
};
</script>

<style scoped>
.btn {
  border: 1px solid #569bb1 !important;
}
</style>



// WEBPACK FOOTER //
// Shortcuts.vue?426615ac